// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CircleImg_wrap_2NzQl"};